import { render, staticRenderFns } from "./EditSquad.vue?vue&type=template&id=71f3a3a8"
import script from "./EditSquad.vue?vue&type=script&lang=js"
export * from "./EditSquad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports